import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import './Header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLangDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleLangDropdown = () => {
    setLangDropdownOpen(!langDropdownOpen);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLangDropdownOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="hero" smooth={true} duration={600} offset={-80} className="logo">
            <img src="/logo.svg" alt="LOGA" className="logo-image" />
            <span className="logo-text">LOGA</span>
          </Link>

          <button
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`nav ${menuOpen ? 'open' : ''}`}>
            <Link
              to="services"
              smooth={true}
              duration={600}
              offset={-80}
              onClick={closeMenu}
              className="nav-link"
            >
              {t('nav.services')}
            </Link>
            <Link
              to="about"
              smooth={true}
              duration={600}
              offset={-80}
              onClick={closeMenu}
              className="nav-link"
            >
              {t('nav.about')}
            </Link>
            <Link
              to="contact"
              smooth={true}
              duration={600}
              offset={-80}
              onClick={closeMenu}
              className="nav-link nav-link-contact"
            >
              {t('nav.contact')}
            </Link>

            <div className="language-dropdown" ref={dropdownRef}>
              <button
                className="language-dropdown-toggle"
                onClick={toggleLangDropdown}
                aria-label="Change language"
              >
                <span className="flag-icon">
                  {i18n.language === 'hr' ? '🇭🇷' : '🇬🇧'}
                </span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                  <path d="M6 8L2 4h8z" />
                </svg>
              </button>

              {langDropdownOpen && (
                <div className="language-dropdown-menu">
                  <button
                    className={`language-dropdown-item ${i18n.language === 'hr' ? 'active' : ''}`}
                    onClick={() => changeLanguage('hr')}
                  >
                    <span className="flag-icon">🇭🇷</span>
                    <span>Hrvatski</span>
                  </button>
                  <button
                    className={`language-dropdown-item ${i18n.language === 'en' ? 'active' : ''}`}
                    onClick={() => changeLanguage('en')}
                  >
                    <span className="flag-icon">🇬🇧</span>
                    <span>English</span>
                  </button>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;